<template>
  <div v-if="products">

    <div class="modal micromodal-slide" id="modal-1" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
          <header class="modal__header">
            <h2 class="modal__title" id="modal-1-title">
              Получить предложение
            </h2>
            <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
          </header>
          <form @submit.prevent="formSubmit" v-if="!result">
            <main class="modal__content" id="modal-1-content">
              <div class="block">
                <p>ФИО</p>
                <input type="text" v-model="name" required>
              </div>
              <div class="block">
                <p>E-mail</p>
                <input type="email" v-model="email" required>
              </div>
            </main>
            <footer class="modal__footer">
              <button :disabled="!isEmailValid" type="submit" class="modal__btn modal__btn-primary">Получить</button>
            </footer>
          </form>
          <div v-else>
            <p>Предложение успешно отправлено на ваш электронный ящик, спасибо!</p>
            <span @click="result = false" class="modal__btn modal__btn-primary">Отравить на другой ящик</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import MicroModal from "micromodal";
import axios from "axios";
import goals from "../../goals";

const emailCheckRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export default {

  name: "ModalDeal",
  props: ['products', 'filter', 'links', 'userHash'],
  data() {
    return {
      name: '',
      email: '',
      result: false,
      productsWithLinks: [],
    }
  },
  computed: {
    isEmailValid()
    {
      return emailCheckRegex.test(this.email);
    },
  },
  methods: {
    formSubmit() {
      this.products.forEach( product => {
        product.link = this.getLink(product.label)
      } )
        // axios.post('/api/index.php', {
        axios.post('/upl_files/modules/select_backend/mailer/index.php', {
        modification: true,
        products : this.products,
        name: this.name,
        email: this.email,
        filter: this.filter,
        userHash: this.userHash ? this.userHash : '23cfec48cb63b586ffe63e5b4f93fe6a'
      }).then( res => res.data.result ? this.result = true : false)
      goals.getMail(this.email)
    },
    getLink(label)
    {
      return this.links[label]
    },
  },
  mounted()
  {
    MicroModal.init({
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false
    });

    // if (this.products) {
    //   this.products.forEach( product => {
    //     product.link = this.getLink(product.label)
    //   } )
    // }


  }
}
</script>

<style scoped>

button:disabled,
button[disabled] {
  background-color: #e0e5e8!important;
}

form {
  font-size: 14px;
}
input {
  border: 1px solid #ccc;
  outline-width: 0;
  border-radius: 3px;
  height: 30px;
  padding-left: 11px;
  padding-top: 1px;
  padding-bottom: 1px;
  margin: 0;
  width: 100%;
  display: block;
  color: #343536;
  font-size: .95em;
  font-weight: 500;
}
</style>

<style>

.block {
  margin-bottom: 10px;
}

.modal {
  display: none;
}

.modal.is-open {
  display: block;
}

/**************************\
 Basic Modal Styles
\**************************/
.modal {
  display: none;
}

.modal.is-open {
  display: block;
}

.modal {
  font-family: -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif;
}

.modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 23;
}

.modal__container {
  background-color: #fff;
  padding: 30px;
  width: 500px;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
}

.modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal__title {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25;
  color: #2c3e50;
  box-sizing: border-box;
}

.modal__close {
  background: transparent;
  border: 0;
}

.modal__header .modal__close:before {
  content: "\2715";
}

.modal__content {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, .8);
}

.modal__btn {
  font-size: .875rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  background-color: #e6e6e6;
  color: rgba(0, 0, 0, .8);
  border-radius: .25rem;
  border-style: none;
  border-width: 0;
  cursor: pointer;
  -webkit-appearance: button;
  text-transform: none;
  overflow: visible;
  line-height: 1.15;
  margin: 0;
  will-change: transform;
  -moz-osx-font-smoothing: grayscale;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  transition: -webkit-transform .25s ease-out;
  transition: transform .25s ease-out;
  transition: transform .25s ease-out, -webkit-transform .25s ease-out;
}

.modal__btn:focus, .modal__btn:hover {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}

.modal__btn-primary {
  background-color: #008f86;
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
}


/**************************\
  Demo Animation Style
\**************************/
@keyframes mmfadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes mmfadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes mmslideIn {
  from {
    transform: translateY(15%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes mmslideOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10%);
  }
}

.micromodal-slide {
  display: none;
}

.micromodal-slide.is-open {
  display: block;
}

.micromodal-slide[aria-hidden="false"] .modal__overlay {
  animation: mmfadeIn .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="false"] .modal__container {
  animation: mmslideIn .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__overlay {
  animation: mmfadeOut .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__container {
  animation: mmslideOut .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide .modal__container,
.micromodal-slide .modal__overlay {
  will-change: transform;
}

</style>